module.exports = __webpack_public_path__ + "img/amazon-small.0116c4a3.svg";